export default __webpack_public_path__ + "static/media/amediateka.392491f4.svg";